import React from 'react';
import I18n from 'i18n-js';
import Currency from '@reverbdotcom/commons/src/currency';
import { PaymentProvider } from './payment_provider';

interface Props {
  shopCurrency: string;
  payoutCurrency: string;
  paymentProvider: PaymentProvider;
}

function currencySymbol(currencyCode: string) {
  if (!currencyCode) {
    return '';
  }

  return Currency.get(currencyCode).symbol;
}

export default function CurrencyExchangeFeeWarning(props: Props) {
  if (props.paymentProvider !== PaymentProvider.ReverbPayments || props.shopCurrency === props.payoutCurrency) {
    return null;
  }

  return (
    <p className="small">
      {I18n.t(
        'discovery.payoutMethod.directCheckoutProfile.bankAccountFields.dashboardCurrencyExchangeFeeWarning',
        {
          shopCurrencySymbol: currencySymbol(props.shopCurrency),
          shopCurrencyCode: props.shopCurrency,
        },
      )}
    </p>
  );
}
